// @ts-nocheck

/**
 * * `PENDING` - Pending Payment
 * `PAID` - Paid
 * `PROCESSING` - Processing
 * `SHIPPED` - Shipped
 * `DELIVERED` - Delivered
 * `CANCELLED` - Cancelled
 * `REFUNDED` - Refunded
 */
export type PhysicalOrderStatusEnum =
  typeof PhysicalOrderStatusEnum[keyof typeof PhysicalOrderStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PhysicalOrderStatusEnum = {
  PENDING: "PENDING",
  PAID: "PAID",
  PROCESSING: "PROCESSING",
  SHIPPED: "SHIPPED",
  DELIVERED: "DELIVERED",
  CANCELLED: "CANCELLED",
  REFUNDED: "REFUNDED",
} as const;
